import React from 'react';

const PrivacyTemplate = () => {
  return (
    <section className="sub_container pt-0">
      <ul className="hd_info">
        <li>
          <span>공고일</span>
          2024.08.20
        </li>
        <li>
          <span>개정사항</span>
          약관내용수정
        </li>
        <li>
          <span>시행일</span>
          2024.08.20
        </li>
      </ul>

      <div className="Padding-20 text">
        회사는 서비스내에 회원이 요청한 처방전 불러오기 서비스를 제공하기 위해 아래와 같은 개인정보를 이용하고자 합니다.
        <br />
        <br />
        <strong>(1)개인정보 수집·이용 목적</strong>
        <br />
        - 건강보험심사평가원 대표홈페이지 서비스 이용을 위함
        <br />
        <br />
        <strong>(2)수집하려는 개인정보의 항목</strong>
        <br />
        - 필수항목: 성명, 주민등록번호, 휴대전화번호
        <br />
        - 자동 수집되는 항목: 이용자가 선택한 인증사업자, CI(연계정보) 또는 DI(중복가입확인정보), IP주소
        <br />
        <br />
        <strong>(3)개인정보의 보유 및 이용기간</strong>
        <br />
        - 이용자가 서비스를 이용하는 기간에 한하여 보유 및 이용. 다만, 아래의 경우는 제외
        <br />
        - 법령에서 정하는 경우 해당 기간까지 보유(상세 사항은 회사의 개인정보처리방침에 기재된 바에 따름)
        <br />
        <br />
        <strong>(4)동의 거부 권리</strong>
        <br />
        신청인은 위의 개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 대표홈페이지 서비스 이용이 제한될 수 있습니다.
      </div>
    </section>
  );
};

export default PrivacyTemplate;
